import ChartTemplate from "@/components/chart-template";
import { ClientMetricsRow } from "@/http/api-types";
import { formatDateToMYYYY } from "@/lib/utils";
import { subMonths } from "date-fns";
import { last12Months } from "..";
import GenericClientChart from "./generic-client-chart";

type ChurnedClientProps = {
  audienceData: ClientMetricsRow[];
  clients: {
    churnedLastMonth: number;
    churnedPreviousMonth: number;
  };
};

function ChurnedClients({ audienceData, clients }: ChurnedClientProps) {
  const chartData = [] as { dateTime: string; month_year: string; clients: number }[];
  const churnedClientNames: { [key: string]: string[] } = {};

  const monthToOrganizations = audienceData.reduce(
    (acc, row) => {
      acc[row.month_year] = row.active_organizations || [];
      return acc;
    },
    {} as { [key: string]: { id: number; name: string }[] },
  );

  last12Months().forEach((month, index) => {
    const previousMonth = formatDateToMYYYY(subMonths(new Date(month), 1));
    const activeOrgsInMonth = monthToOrganizations[month] || [];
    const activeOrgsInPreviousMonth = monthToOrganizations[previousMonth] || [];

    const activeOrgIdsInMonth = activeOrgsInMonth.map(org => org.id);
    const churnedOrgs = activeOrgsInPreviousMonth.filter(org => !activeOrgIdsInMonth.includes(org.id));

    chartData.push({
      month_year: month,
      dateTime: new Date(month).toLocaleDateString("en-US", {
        month: "short",
        year: "numeric",
      }),
      clients: churnedOrgs.length,
    });
    churnedClientNames[month] = churnedOrgs.map(org => org.name);
  });

  return (
    <ChartTemplate
      timeSplittable={false}
      summaryMetric={clients.churnedLastMonth.toString()}
      summaryMetricLabel="Last Month"
      title="Churned Clients"
      description="The clients that were active in the previous month but not anymore"
      chart={
        <GenericClientChart
          chartData={chartData.sort((a, b) => (a.month_year > b.month_year ? 1 : -1))}
          clientNames={churnedClientNames}
        />
      }
      table={null}
    ></ChartTemplate>
  );
}

export default ChurnedClients;
